import React from "react";
import {
  BarChartOutlined,
  DashboardOutlined,
  FieldTimeOutlined,
  FilePptOutlined,
  SettingOutlined,
  SnippetsOutlined,
  UserOutlined,
  DollarCircleOutlined,
  PropertySafetyOutlined,
  CloudDownloadOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { t } from "i18next";

const menuItems = [
  {
    label: <Link to="/">{t("text_dashboard")}</Link>,
    icon: <DashboardOutlined />,
    key: "/",
  },
  {
    label: <Link to="/donor">{t("text_donor")}</Link>,
    icon: <SnippetsOutlined />,
    key: "/donor",
  },
  {
    label: <Link to="/employees">{t("text_employees")}</Link>,
    icon: <UserOutlined />,
    key: "/employees",
  },
  {
    label: <Link to="/salary-scale-record">{t("text_salary_scale_record")}</Link>,
    icon: <DollarCircleOutlined />,
    key: "/salary-scale-record",
  },
  {
    label: <Link to="/timesheets">{t("text_timesheet")}</Link>,
    icon: <FieldTimeOutlined />,
    key: "/timesheets",
  },
  {
    label: <Link to="/overtime-request">{t("text_overtime_request")}</Link>,
    icon: <FieldTimeOutlined />,
    key: "/overtime-request",
  },
  // {
  //   label: <Link to="/leaves">{t("text_leaves_request")}</Link>,
  //   key: "/leaves",
  //   icon: <FileTextOutlined />,
  // },
  {
    label: <Link to="/payrolls">{t("text_payroll")}</Link>,
    key: "/payrolls",
    icon: <FilePptOutlined />,
  },
  {
    label: "Performance",
    key: "/performance",
    icon: <PropertySafetyOutlined />,
    children: [
      {
        label: <Link to="/performance/pdd">Objectives Setting</Link>,
        key: "/performance/pdd",
      },
      {
        label: <Link to="/performance/quarterly-review">Quarterly Review</Link>,
        key: "/performance/quarterly-review",
      },
      {
        label: <Link to="/performance/appraisal">Year-End Appraisal</Link>,
        key: "/performance/appraisal",
      },
      {
        label: <Link to="/performance/pip">PIP</Link>,
        key: "/performance/pip",
      },
      {
        label: <Link to="/performance/performance-module">Setting</Link>,
        key: "/performance/performance-module",
      },
    ],
  },
  {
    label: t("text_reports"),
    key: "/reports",
    icon: <BarChartOutlined />,
    children: [
      {
        label: <Link to="/reports/leaves">{t("text_leave_reports")}</Link>,
        key: "/reports/leaves",
      },
      {
        label: <Link to="/reports/overtime">{t("text_overtime_report")}</Link>,
        key: "/reports/overtime",
      },
      {
        label: <Link to="/reports/payroll">{t("text_payroll_report")}</Link>,
        key: "/reports/payroll",
      },
    ],
  },
  {
    label: <Link to="/setting">{t("text_settings")}</Link>,
    key: "/setting",
    icon: <SettingOutlined />,
  },
  {
    label: <Link to="/backup_restore">{t("text_backup_restore")}</Link>,
    key: "/backup_restore",
    icon: <CloudDownloadOutlined />,
  },
];

export default menuItems;
